import { Vector3 } from "three";

// Specified key that merges certain properties together based on interaction. This basically says which properties
// need to be hidden when a certain property was changed
export const LINKED_PROPERTIES = "linkedProperties";
export const PART = "part";
export const COLOUR = "color";
export const COLOUR_VARIANT = "colorvariant";

export const NORMALIZED_X_AXIS = new Vector3(1, 0, 0);
export const NORMALIZED_Y_AXIS = new Vector3(0, 1, 0);
export const NORMALIZED_Z_AXIS = new Vector3(0, 0, 1);
